// extracted by mini-css-extract-plugin
export default {"productGallery":"lJ-z","inQuickShop":"mJ-z"};